<template>
  <div id="allDeviceDetail">
    <!-- 设备信息--设备信息图表、设备信息详情 -->
    <el-row :gutter="40" style="margin-bottom: 20px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <div class="headTitle">
          <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
          <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
          <span class="fontStyle2" />
          <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}:V{{ basicinfo.fwVersion }}</span><!--固件-->
        </div>
        <div class="headTitle">
          <span style="font-size: 20px;margin-right: 20px;">{{ $t("basicinfo.Voltage") }}: {{ mqttObj.TotalVoltage }} V</span>
          <span class="fontStyle2" />
          <span v-if="mqttObj.chargeDisStatu=='idel'" style="font-size: 20px;margin-right: 20px;">{{ $t("AllDevices.Current") }}: {{ mqttObj.current }} A</span>
          <span v-else-if="mqttObj.chargeDisStatu=='charge'" style="font-size: 20px;margin-right: 20px;">{{ $t("AllDevices.ChargeCurrent") }}: {{ mqttObj.ChargeCurent }} A</span>
          <span v-else-if="mqttObj.chargeDisStatu=='disCharge'" style="font-size: 20px;margin-right: 20px;">{{ $t("AllDevices.DischargeCurrent") }}: {{ mqttObj.DisChargeCurent }} A</span>
          <span class="fontStyle2" />
          <span style="font-size: 20px;margin-right: 20px;">{{ $t("warningPage.SOC") }}: {{ mqttObj.SOC }} %</span>
          <span v-if="mqttObj.ErrorCode" class="fontStyle2" />
          <span v-if="mqttObj.ErrorCode" style="font-size: 20px;margin-right: 20px;">故障码: {{ mqttObj.ErrorCode }}</span>
          <span class="fontStyle2" />
          <span style="font-size: 20px;margin-right: 20px;">{{ $t("dashboard.LatestUpdate") }}: {{ mqttObj.updateTime }}</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="40" style="margin: 0px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col" style="padding: 20px;background: #fff;">
        <div style="display:flex;align-items:center;justify-content:flex-end;margin-bottom:10px">
          <div style="display: inline-block;vertical-align: top;">
            <el-date-picker v-model="selectDayTable" :end-placeholder="$t('AllDevices.endDate')" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" type="daterange" @change="tableSearch" />
          </div>
          <el-button icon="el-icon-download" style="vertical-align: top;margin-left: 20px;float: right;position: relative;z-index: 999;" type="primary" @click="download" />
        </div>

        <el-table v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
          <el-table-column label="数据上传时间" align="center" min-width="20%">
            <template slot-scope="scope">
              <span>{{ scope.row.yhubTimeZh }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数据" align="center" min-width="80%">
            <template slot-scope="scope">
              <span>{{ scope.row.jsonData }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo, findLithiumEVDeviceList, exportMsgEVbmsData } from '@/api/allDevice'
import { GetRealTimeData } from '@/api/leaseManagement'
import { getDateAndHour, howLongAgo2, usedTime, howLongAgo } from '@/utils/updateTime.js'
import { pagination } from '@/utils/init_table' // 分页

export default {
  name: 'DashboardAdmin',
  components: {
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      yhubmqtt: {},
      basicinfo: {},
      listLoading: false,
      list: [],
      selectDayTable: [], // 日期选择
      mqttObj: {
        TotalVoltage: '--',
        ChargeCurrent: '--',
        DischargeCurrent: '--',
        SOC: '--',
        chargeDisStatu: 'idel',
        current: '--',
        updateTime: '--',
        ErrorCode: 0
      }
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    storeYhubmqtt() {
      // console.log('------', this.$store.state.yhubmqtt)
      return this.$store.state.yhubmqtt// 需要监听的数据
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
      this.MQTT()
      // this.timeAgo = ''; this.timeAgo = howLongAgo(this.timeAgoRST)
    },
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        this.MQTT()
      },
      deep: true
    }
  },
  mounted() {
    this.queryList()
    this.queryTable()
  },
  created() {
  },
  destroyed: function() {
  },
  methods: {
    queryList() {
      var param = {
        'mcuId': this.$route.query.mcuId
      }
      // 设备信息
      findDeviceInfo(param).then(res => {
        // 设备信息详情
        this.basicinfo = res.resultModel
        this.basicinfo.batteryCapacity = Math.round(res.resultModel.batteryCapacity / 100)
      })
    },
    queryTable() {
      var param = {
        endDate: null,
        mcuId: this.$route.query.mcuId,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        startDate: null
      }
      if (this.selectDayTable && this.selectDayTable.length > 0) {
        param.startDate = new Date(this.selectDayTable[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDayTable[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      }
      findLithiumEVDeviceList(param).then(res => {
        if (res.resultCode !== 1001 || !res.resultModel) return
        // res.resultModel.list.forEach(v => {
        //   if (v.yhubTime)v.yhubTimeZh = getDateAndHour(v.yhubTime)
        // })
        // this.list = res.resultModel.list
        // this.listQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    tableSearch() { // 筛选
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryTable()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    download() {
      var param = {
        mcuId: this.$route.query.mcuId,
        startDate: null,
        endDate: null
      }
      if (this.selectDayTable && this.selectDayTable.length > 0) {
        param.startDate = new Date(this.selectDayTable[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDayTable[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      } else {
        this.$message({
          type: 'error',
          message: '请选择数据起止日期！'
        })
        return
      }
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportMsgEVbmsData?mcuId='
      url += param.mcuId + '&sn=' + this.basicinfo.deviceSn + '&startDate=' + param.startDate + '&endDate=' + param.endDate + '&showAll=false'
      window.open(url, '_bank')
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end

    MQTT() {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        // console.log(this.yhubmqtt.payload)
        // console.log(this.myDeviceType)
        // mErrorCode.mUploadBMSRecordReq.batteryVoltage mErrorCode.payload mErrorCode.mBMSData.BMS2CarFrame1
        // console.log('MQTT=======', this.yhubmqtt)
        if (this.yhubmqtt.payload === 'mCan') {
          console.log('MQTT==mCan=====', this.yhubmqtt)
          if (this.yhubmqtt && this.yhubmqtt.mCan && this.yhubmqtt.mCan.mMsgEVbmsData) {
            var mMsgEVbmsData = this.yhubmqtt.mCan.mMsgEVbmsData || {}
            // console.log(mMsgEVbmsData)
            if (this.list.length == 10000) {
              this.list.splice(9999, 1)
            }
            this.list.unshift({
              yhubTimeZh: getDateAndHour(mMsgEVbmsData.TimeStamp * 1000),
              jsonData: mMsgEVbmsData
            })
            this.mqttObj.TotalVoltage = mMsgEVbmsData.TotalVoltage / 1000
            this.mqttObj.SOC = mMsgEVbmsData.SOC
            this.mqttObj.ErrorCode = mMsgEVbmsData.ErrorCode
            if (!mMsgEVbmsData.ChargeCurent)mMsgEVbmsData.ChargeCurent = 0
            if (!mMsgEVbmsData.DisChargeCurent)mMsgEVbmsData.DisChargeCurent = 0
            this.mqttObj.ChargeCurent = mMsgEVbmsData.ChargeCurent
            this.mqttObj.DisChargeCurent = mMsgEVbmsData.DisChargeCurent
            var current = mMsgEVbmsData.ChargeCurent - mMsgEVbmsData.DisChargeCurent
            if (current == 0) {
              this.mqttObj.chargeDisStatu = 'idel'
              this.mqttObj.current = 0
            } else {
              this.mqttObj.chargeDisStatu = current > 0 ? 'charge' : 'disCharge'
            }
            if (mMsgEVbmsData.TimeStamp) {
              this.mqttObj.updateTime = getDateAndHour(mMsgEVbmsData.TimeStamp * 1000)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.changePieBtn{
  outline: none;    //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border:1px solid #c2e7b0;
  background:#f0f9eb;
  margin-bottom: 10px;
  position: relative;
  margin-left: calc(1% + 5px);
}
.active{
  border:1px solid #67c23a;
  background:#67c23a;
  color:white;
}
.questionPop{
  display: none;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  bottom: 165px;
  left: 10px;
  max-width: 100%;
}
.card-panel{
  padding-bottom: 20px;
}
.blockContentDiv{
  padding:0 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.deviceInfoChart{
  width:49%;
  display:inline-block;
  // border:1px solid red;
  height:250px;
}
.deviceInfoDetail{
  width:100%;
  // border:1px solid red;
}
.deviceInfoDetailP{
  line-height:43px;
  position: relative;
}
.deviceInfoDetailBtn{
  position: absolute;
  right: 0;
}
.statusContentWarp{
  height:100%;
  // border:1px solid red;
}
.warningWrap{
  // height: 250px;
  padding: 15px 5%;;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  // justify-content: space-around;
  text-align: center;
  overflow-y: auto;
}
.warningDivs{
  display: inline-block;
}
.warningImg{
  width:70px;
  height:70px;
  display: inline-block;
}
.redWarningRadiu{
  font-size: 20px;
  margin-top: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
  position: absolute;
  z-index: 200;
  background: red;
  border-radius: 50%;
  // left: calc(50% + 15px);
  // top: 0px;
  right: 18px;
  top: 2px;
}
.redRadiu{
  display: inline-block;
  width: 13px;
  height: 13px;
  background: #ca6a6a;
  border-radius: 50%;
  position: absolute;
  top: 13px;
  left: -17px;
}
</style>
<style lang="scss">
#allDeviceDetail{
  .el-form-item{
    width:100%;
    position: relative;
  }
  .el-form-item__content{
    width:calc(100% - 180px);
  }
  .el-autocomplete,.el-cascader--medium,.el-input{
    width:100%!important;
  }
  .ycdd .el-input {
    width: 80px !important;
    margin-right: 10px;
  }
  .ycdd .el-input__inner {
    padding:0 10px;
  }
  .el-dialog{
    // margin-top: 5vh!important;
  }
  .el-select{
    width:100%;
  }
  .el-select-dropdown__item.selected {
    color: #606266;
    font-weight: normal;
  }
  .setting .el-form-item__label{
    color: #1990fc;
  }
  .el-row{
    // padding-right: 30px;
  }
  .cellNumberInfoPop{
    display: inline-block;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    bottom: 64px;
    max-width: 100%;
    right: 0;
    width: auto;
  }
  .cellNumber{
    position: relative;
  }
  .cellNumber .el-icon-question{
    position: absolute;
    top: 7px;
    font-size: 18px;
    color: #858585;
    z-index: 999;
    right: -20px;
  }
  .el-table__body-wrapper{
    max-height: 550px;
    overflow-y: auto;
  }
  .headTitle:nth-of-type(1){
    height: auto;
    padding: 20px 20px 10px;
    // border-bottom: 1px solid #c1c1c1;
  }
  .headTitle:nth-of-type(2){
    height: auto;
    padding: 10px 20px 20px;
  }
}

</style>

